(function(){
  'use strict';
  var WHATSAPP = "hidden"; // WhatsApp username (or number without "+") used in wa.me links
  var EMAIL = "info@dubaiwallarts.com";
  var $ = function(id){ return document.getElementById(id); };
  function money(n){ return 'AED '+Number(n).toLocaleString('en-US'); }
  function el(tag,cls,txt){var n=document.createElement(tag);if(cls)n.className=cls;if(txt!=null)n.textContent=txt;return n;}


  /* ---- Shopify contact form (replaces Netlify forms) ----
     Shopify rejects plain fetch posts ("Missing CAPTCHA token"). A hidden real contact form is protected with Shopify.captcha.protect()
     and posted natively; Shopify redirects back to the same page with ?contact_posted=true (handled at the end of this file). */
  var cform=null,cprot=false;
  function ensureForm(){
    if(cform)return cform;
    var f=document.createElement('form');f.id='dwaContact';f.method='post';f.action='/contact#contact_form';f.setAttribute('accept-charset','UTF-8');f.hidden=true;
    f.innerHTML='<input type="hidden" name="form_type" value="contact"><input type="hidden" name="utf8" value="\u2713"><input name="contact[name]"><input name="contact[email]"><input name="contact[phone]"><textarea name="contact[body]"></textarea>';
    document.body.appendChild(f);cform=f;return f;
  }
  function protect(){
    var f=ensureForm();if(cprot)return true;
    try{if(window.Shopify&&Shopify.captcha&&typeof Shopify.captcha.protect==='function'){Shopify.captcha.protect(f,function(){});cprot=true;}}catch(e){}
    return cprot;
  }
  document.addEventListener('focusin',function(e){var t=e.target;if(t&&t.closest&&t.closest('#orderForm,form.askform,form.bizform'))protect();});
  function sendContact(fields,text,pending){
    var f=ensureForm(),wasReady=cprot,ok=protect();
    f.elements['contact[name]'].value=fields.name||'';f.elements['contact[email]'].value=fields.email||'';f.elements['contact[phone]'].value=fields.phone||'';f.elements['contact[body]'].value=text;
    try{sessionStorage.setItem('dwa_pending',JSON.stringify(pending||{}));}catch(e){}
    return new Promise(function(res,rej){
      if(!ok){rej(new Error('captcha unavailable'));return;}
      setTimeout(function(){try{if(f.requestSubmit)f.requestSubmit();else f.submit();}catch(e){rej(e);}},wasReady?0:2500);
      setTimeout(function(){rej(new Error('timeout'));},30000);
    });
  }
  function formText(f,title){
    var out=[title],els=f.elements;
    for(var i=0;i<els.length;i++){var e=els[i];if(!e.name||e.type==='submit'||e.type==='hidden'||e.name==='bot-field')continue;if(e.value)out.push(e.name+': '+e.value);}
    return out.join('\n');
  }

  /* ---- cart ---- */
  var KEY='dwa_cart_v2', cart=[];
  function valid(i){return i&&typeof i.key==='string'&&typeof i.title==='string'&&typeof i.price==='number'&&typeof i.qty==='number'&&i.qty>0&&i.qty<100;}
  function load(){try{var r=JSON.parse(localStorage.getItem(KEY)||'[]');cart=Array.isArray(r)?r.filter(valid):[];}catch(e){cart=[];}}
  function save(){try{localStorage.setItem(KEY,JSON.stringify(cart));}catch(e){}}
  function total(){return cart.reduce(function(s,i){return s+i.price*i.qty;},0);}
  function count(){return cart.reduce(function(s,i){return s+i.qty;},0);}
  var toastT;
  function toast(msg){var t=$('toast');t.textContent=msg;t.classList.add('on');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('on');},1800);}

  function renderCart(){
    $('cartCount').textContent=count();
    $('cartTotal').textContent=money(total());
    $('checkoutBtn').disabled=cart.length===0;
    var box=$('cartItems');box.textContent='';
    if(!cart.length){box.appendChild(el('p','empty','Your cart is empty.'));return;}
    cart.forEach(function(it,idx){
      var row=el('div','line'),img=document.createElement('img');
      img.src=it.img||'';img.alt='';row.appendChild(img);
      var info=el('div'),t=el('a','t',it.title);
      if(it.url){t.href=it.url;}
      info.appendChild(t);
      if(it.size)info.appendChild(el('div','m',it.size));
      var r=el('div','r'),q=el('div','qty'),minus=el('button',null,'−'),plus=el('button',null,'+'),n=el('span',null,String(it.qty));
      minus.type='button';plus.type='button';minus.setAttribute('aria-label','Decrease quantity');plus.setAttribute('aria-label','Increase quantity');
      minus.addEventListener('click',function(){changeQty(idx,-1);});plus.addEventListener('click',function(){changeQty(idx,1);});
      q.appendChild(minus);q.appendChild(n);q.appendChild(plus);
      var right=el('div');right.style.textAlign='right';
      right.appendChild(el('div',null,money(it.price*it.qty)));
      var rm=el('button','rm','Remove');rm.type='button';rm.addEventListener('click',function(){cart.splice(idx,1);save();renderCart();});
      right.appendChild(rm);
      r.appendChild(q);r.appendChild(right);info.appendChild(r);row.appendChild(info);box.appendChild(row);
    });
  }
  function changeQty(idx,d){
    var it=cart[idx];if(!it)return;it.qty+=d;
    if(it.qty<1)cart.splice(idx,1);else if(it.qty>99)it.qty=99;
    save();renderCart();
  }
  function addItem(item,qty){
    var found=null;cart.forEach(function(i){if(i.key===item.key)found=i;});
    if(found)found.qty=Math.min(99,found.qty+qty);
    else{item.qty=qty;cart.push(item);}
    save();renderCart();
  }

  /* ---- drawer ---- */
  function openCart(){$('drawer').classList.add('on');$('scrim').classList.add('on');$('drawer').setAttribute('aria-hidden','false');document.body.classList.add('noscroll');$('closeCart').focus();}
  function closeCart(){$('drawer').classList.remove('on');$('scrim').classList.remove('on');$('drawer').setAttribute('aria-hidden','true');document.body.classList.remove('noscroll');}
  $('cartBtn').addEventListener('click',openCart);
  $('closeCart').addEventListener('click',closeCart);
  $('scrim').addEventListener('click',closeCart);

  /* ---- order request ---- */
  function summaryText(){
    return cart.map(function(i){
      return i.qty+' × '+i.title+(i.size?' ('+i.size+')':'')+' — AED '+i.price+' each';
    }).join('\n');
  }
  var form=$('orderForm'),modal=$('orderModal');
  function openOrder(){
    if(!cart.length)return;
    closeCart();
    $('orderFormWrap').hidden=false;$('orderDone').hidden=true;
    $('orderSummary').textContent=summaryText()+'\nEstimated total: AED '+total();
    $('fRef').value='DWA-'+Date.now().toString(36).toUpperCase();
    $('fItems').value=summaryText();
    $('fTotal').value='AED '+total();
    $('orderErr').hidden=true;
    modal.classList.add('on');document.body.classList.add('noscroll');
    var first=form.querySelector('input[name=name]');if(first)first.focus();
  }
  function closeOrder(){modal.classList.remove('on');document.body.classList.remove('noscroll');}
  $('checkoutBtn').addEventListener('click',openOrder);
  $('closeOrder').addEventListener('click',closeOrder);
  $('doneClose').addEventListener('click',closeOrder);
  modal.addEventListener('click',function(e){if(e.target===modal)closeOrder();});

  function waLink(ref,name){
    if(!WHATSAPP)return null;
    var msg='Hello Dubai Wall Arts, my order request '+ref+(name?' ('+name+')':'')+':\n'+summaryText()+'\nEstimated total: AED '+total();
    return window.dwaWaUrl?window.dwaWaUrl(msg):'https://wa.me/'+WHATSAPP+'?text='+encodeURIComponent(msg);
  }
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=$('sendOrder'),err=$('orderErr');err.hidden=true;btn.disabled=true;btn.textContent='Sending…';
    var hp=form.elements['bot-field'];
    var ref=$('fRef').value,name=form.elements['name'].value;
    var wa=waLink(ref,name);
    var ordText='Order request '+ref+'\n'+formText(form,'')+'\nItems:\n'+summaryText()+'\nEstimated total: AED '+total();
    (hp&&hp.value?Promise.resolve():sendContact({name:form.elements['name'].value,email:form.elements['email'].value,phone:form.elements['phone'].value},ordText,{kind:'order',ref:ref,wa:wa||''}))
      .then(function(r){
        $('doneRef').textContent=ref;
        var a=$('waLink');if(wa){a.href=wa;a.hidden=false;}else a.hidden=true;
        $('orderFormWrap').hidden=true;$('orderDone').hidden=false;
        cart=[];save();renderCart();form.reset();
      })
      .catch(function(){
        err.hidden=false;
        var mail='mailto:'+EMAIL+'?subject='+encodeURIComponent('Order request '+ref)+'&body='+encodeURIComponent(summaryText()+'\nEstimated total: AED '+total()+'\n\nName: '+name+'\nPhone: '+form.elements['phone'].value);
        err.textContent='';
        err.appendChild(document.createTextNode('We could not send your request automatically. '));
        var a=document.createElement('a');a.href=mail;a.textContent='Send it by email instead';err.appendChild(a);
        if(wa){err.appendChild(document.createTextNode(' or '));var w=document.createElement('a');w.href=wa;w.target='_blank';w.rel='noopener';w.textContent='use WhatsApp';err.appendChild(w);}
        err.appendChild(document.createTextNode('.'));
      })
      .then(function(){btn.disabled=false;btn.textContent='Send order request';});
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeCart();closeOrder();}});

  /* ---- home: category filter + show more ---- */
  var grid=$('grid');
  if(grid&&$('more')){
    var cards=[].slice.call(grid.querySelectorAll('.card')),chips=[].slice.call(document.querySelectorAll('.chip')),
        more=$('more'),LIMIT=16,cur='all',shown=LIMIT;
    var orig=cards.slice(),sortSel=$('sortSel'),cnt=$('resultCount');
    var render=function(){
      var m=0;cards.forEach(function(c){
        var ok=cur==='all'||(' '+c.dataset.cat+' ').indexOf(' '+cur+' ')>=0;
        if(ok){m++;c.hidden=m>shown;}else c.hidden=true;
      });
      more.hidden=m<=shown;
      if(cnt)cnt.textContent=m+(m===1?' product':' products');
    };
    var num=function(c,k){return Number(c.dataset[k]);};
    var sortCards=function(mode){
      var a=orig.slice();
      if(mode==='new')a.sort(function(x,y){return num(y,'idx')-num(x,'idx');});
      else if(mode==='old')a.sort(function(x,y){return num(x,'idx')-num(y,'idx');});
      else if(mode==='plow')a.sort(function(x,y){return num(x,'price')-num(y,'price')||num(x,'idx')-num(y,'idx');});
      else if(mode==='phigh')a.sort(function(x,y){return num(y,'price')-num(x,'price')||num(x,'idx')-num(y,'idx');});
      cards=a;a.forEach(function(c){grid.appendChild(c);});
      shown=LIMIT;render();
    };
    if(sortSel)sortSel.addEventListener('change',function(){sortCards(sortSel.value);});
    var setFilter=function(f){cur=f;shown=LIMIT;chips.forEach(function(c){c.setAttribute('aria-pressed',String(c.dataset.filter===f));});render();};
    chips.forEach(function(c){c.addEventListener('click',function(){setFilter(c.dataset.filter);});});
    more.addEventListener('click',function(){shown+=LIMIT;render();});
    render();
    var qc=(location.search.match(/[?&]cat=([a-z]+)/)||[])[1];
    if(qc&&chips.some(function(c){return c.dataset.filter===qc;}))setFilter(qc);
  }

  /* ---- home: View all products opens the full filterable list in place ---- */
  var va=$('viewall'),ap=$('allprod'),fg=$('featgrid');
  if(va&&ap&&fg){
    var fh=$('feath'),fp=$('featp'),h0=fh.textContent,p0=fp.textContent;
    var toggleAll=function(open,scroll){
      ap.hidden=!open;fg.hidden=open;va.setAttribute('aria-expanded',String(open));
      va.textContent=open?'Show featured pieces only':'View all products';
      fh.textContent=open?'All Products':h0;
      fp.textContent=open?'Filter by category or sort by price. Open any product to choose your size and read the details.':p0;
      if(scroll){var t=document.getElementById('featured');if(t)t.scrollIntoView({behavior:'smooth',block:'start'});}
    };
    va.addEventListener('click',function(){toggleAll(ap.hidden,true);});
    if(/[?&]cat=/.test(location.search)||location.hash==='#products'){toggleAll(true,false);var go=function(){var t=document.getElementById('featured');if(t)t.scrollIntoView({behavior:'instant',block:'start'});};if(document.readyState==='complete')go();else window.addEventListener('load',go);}
  }

  /* ---- hover preview on product cards (desktop) ---- */
  if(window.matchMedia&&window.matchMedia('(hover:hover)').matches){
    document.addEventListener('mouseover',function(e){
      var c=e.target.closest&&e.target.closest('.card');if(!c||c.classList.contains('hv'))return;
      var z=c.querySelector('.zoom');if(!z)return;
      var l=c.querySelector('.hvl');
      if(!l){
        if(c.dataset.hvv){l=document.createElement('video');l.muted=true;l.loop=true;l.playsInline=true;l.preload='auto';l.src=c.dataset.hvv;}
        else if(c.dataset.hvi){l=document.createElement('img');l.src=c.dataset.hvi;l.alt='';l.decoding='async';}
        else return;
        l.className='hvl';z.appendChild(l);
      }
      c.classList.add('hv');
      if(l.tagName==='VIDEO'){try{l.currentTime=0;l.play();}catch(x){}}
    });
    document.addEventListener('mouseout',function(e){
      var c=e.target.closest&&e.target.closest('.card');if(!c||(e.relatedTarget&&c.contains(e.relatedTarget)))return;
      c.classList.remove('hv');
      var l=c.querySelector('.hvl');if(l&&l.tagName==='VIDEO')l.pause();
    });
  }

  /* ---- product page ---- */
  var pd=$('pdata');
  if(pd){
    var P=JSON.parse(pd.textContent),qty=1;
    var pills=[].slice.call(document.querySelectorAll('#sizePills input'));
    var cur_=function(){var s=0;pills.forEach(function(r){if(r.checked)s=Number(r.value);});return P.sizes[s];};
    var upd=function(){var c=cur_();$('pPrice').textContent=money(c.price);var sn=$('sizeName');if(sn)sn.textContent=c.label;};
    pills.forEach(function(r){r.addEventListener('change',upd);});
    var sws=[].slice.call(document.querySelectorAll('#swatches input'));
    var colour=function(){var n='';sws.forEach(function(r){if(r.checked)n=P.colors[Number(r.value)];});return n;};
    sws.forEach(function(r){r.addEventListener('change',function(){
      var cn=$('colourName');if(cn)cn.textContent=colour();
      var ct=[].slice.call(document.querySelectorAll('.th')).filter(function(b){return b.dataset.src&&b.dataset.src.indexOf('/colour-')>=0;})[0];
      if(ct)ct.click();
    });});
    upd();
    $('qMinus').addEventListener('click',function(){qty=Math.max(1,qty-1);$('qVal').textContent=qty;});
    $('qPlus').addEventListener('click',function(){qty=Math.min(10,qty+1);$('qVal').textContent=qty;});
    $('addBtn').addEventListener('click',function(){
      var s=cur_(),c=colour();
      addItem({key:P.id+'-'+s.label+(c?'-'+c:''),id:P.id,title:P.name,img:P.img,url:location.pathname,
               size:P.sizeLabel+': '+s.label+(c?' · '+(P.colourLabel||'Colour')+': '+c:''),price:s.price},qty);
      toast('Added to cart');openCart();
    });
    var gl=$('guideLink');
    if(gl)gl.addEventListener('click',function(){var d=$('size-guide');if(d)d.open=true;});
    document.querySelectorAll('form.askform').forEach(function(f){
      f.addEventListener('submit',function(e){
        e.preventDefault();
        var b=f.querySelector('button[type=submit]'),m=f.querySelector('.askmsg');
        b.disabled=true;b.textContent='Sending…';
        var pn=f.querySelector('[name=product]'),hp2=f.elements['bot-field'];
        (hp2&&hp2.value?Promise.resolve():sendContact({name:f.elements['name'].value,email:f.elements['email'].value},formText(f,'Question about '+(pn?pn.value:'a product')),{kind:'ask'}))
          .then(function(r){m.hidden=false;m.textContent='Thank you – we will reply by email soon.';f.reset();})
          .catch(function(){m.hidden=false;m.textContent='We could not send your message. Please email '+EMAIL+'.';})
          .then(function(){b.disabled=false;b.textContent='Send question';});
      });
    });
    var vp=$('vplay'),vt=null,vi=0,vbuilt=false,vmain=document.querySelector('.mainimg');
    var stopVideo=function(){if(vt){clearInterval(vt);vt=null;}if(vmain)vmain.classList.remove('playing');};
    var showScene=function(i){
      var sc=vp.querySelectorAll('.vs');
      sc.forEach(function(e,k){e.classList.toggle('on',k===i);});
      var bar=vp.querySelector('.vbar');if(bar)bar.style.width=((i+1)/sc.length*100)+'%';
    };
    var startVideo=function(){
      if(!vp||!P.vimgs)return;
      if(!vbuilt){
        P.vimgs.forEach(function(u,k){
          var d=el('div','vs'),im=document.createElement('img');im.src=u;im.alt='';d.appendChild(im);
          d.appendChild(el('div','vcap',(P.vcaps&&P.vcaps[k])||P.name));vp.appendChild(d);
        });
        vbuilt=true;
      }
      if(vmain)vmain.classList.add('playing');
      vi=0;showScene(0);
    };
    var ths=[].slice.call(document.querySelectorAll('.th')),gi=0,gcount=$('gCount');
    var mark=function(){
      ths.forEach(function(x,k){x.classList.toggle('on',k===gi);});
      if(gcount)gcount.textContent=(gi+1)+' / '+ths.length;
    };
    ths.forEach(function(b,k){
      b.addEventListener('click',function(){
        gi=k;stopVideo();
        if(b.dataset.video){startVideo();}
        else{$('mainImg').src=b.dataset.src;}
        mark();
      });
    });
    var step=function(d){if(ths.length>1)ths[(gi+d+ths.length)%ths.length].click();};
    var gp=$('gPrev'),gn=$('gNext');
    if(gp)gp.addEventListener('click',function(){step(-1);});
    if(gn)gn.addEventListener('click',function(){step(1);});
    document.addEventListener('keydown',function(e){
      var t=e.target&&e.target.tagName;if(t==='INPUT'||t==='TEXTAREA'||t==='SELECT')return;
      if($('drawer').classList.contains('on')||$('orderModal').classList.contains('on'))return;
      if(e.key==='ArrowLeft')step(-1);else if(e.key==='ArrowRight')step(1);
    });
    var tx=null;
    if(vmain){
      vmain.addEventListener('touchstart',function(e){tx=e.touches[0].clientX;},{passive:true});
      vmain.addEventListener('touchend',function(e){
        if(tx===null)return;var dx=e.changedTouches[0].clientX-tx;tx=null;
        if(Math.abs(dx)>40)step(dx<0?1:-1);
      },{passive:true});
    }
    mark();
  }


  /* ---- business project brief ---- */
  document.querySelectorAll('form.bizform').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var b=f.querySelector('button[type=submit]'),m=f.querySelector('.bizmsg');
      if(!m){m=document.createElement('p');m.className='note bizmsg';m.setAttribute('role','status');f.appendChild(m);}
      var hp=f.elements['bot-field'];
      b.disabled=true;b.textContent='Sending…';
      (hp&&hp.value?Promise.resolve():sendContact({name:f.elements['name'].value,email:f.elements['email'].value,phone:f.elements['phone'].value},formText(f,'Business project brief'),{kind:'biz'}))
        .then(function(){m.hidden=false;m.textContent='Thank you – we will reply by email soon.';f.reset();})
        .catch(function(){m.hidden=false;m.textContent='We could not send your brief. Please email '+EMAIL+'.';})
        .then(function(){b.disabled=false;b.textContent='Send project brief';});
    });
  });

  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    document.querySelectorAll('.sv video').forEach(function(v){v.removeAttribute('autoplay');v.pause();});
  }
  load();renderCart();

  /* ---- back from the Shopify contact form (?contact_posted=true) ---- */
  (function(){
    if(!/[?&]contact_posted=true/.test(location.search))return;
    var p={};try{p=JSON.parse(sessionStorage.getItem('dwa_pending')||'{}')||{};sessionStorage.removeItem('dwa_pending');}catch(e){}
    try{history.replaceState(null,'',location.pathname+location.hash.replace('#contact_form',''));}catch(e){}
    if(p.kind==='order'){
      cart=[];save();renderCart();
      $('doneRef').textContent=p.ref||'';
      var a=$('waLink');if(p.wa){a.href=p.wa;a.hidden=false;}else a.hidden=true;
      $('orderFormWrap').hidden=true;$('orderDone').hidden=false;modal.classList.add('on');document.body.classList.add('noscroll');
    }else{
      var fm=document.querySelector(p.kind==='biz'?'form.bizform':'form.askform'),box=fm&&fm.querySelector('.askmsg,.bizmsg');
      if(fm&&!box){box=document.createElement('p');box.className='note bizmsg';box.setAttribute('role','status');fm.appendChild(box);}
      if(box){box.hidden=false;box.textContent='Thank you \u2013 we will reply by email soon.';var dt=box.closest('details');if(dt)dt.open=true;box.scrollIntoView({block:'center'});}
      else toast('Thank you \u2013 we will reply soon.');
    }
  })();
})();
